(() => {
  if (window.egdeProductEditorial) return;
  window.egdeProductEditorial = true;

  const initialized = new WeakSet();
  function initialize() {
    document.querySelectorAll('.egde-product-editorial').forEach((section) => {
      if (initialized.has(section)) return;
      initialized.add(section);

      const update = () => {
        const headerHeight = document.getElementById('header-group')?.getBoundingClientRect().height || 82;
        section.style.setProperty('--egde-gallery-top', `${headerHeight + 24}px`);
      };
      const observer = new ResizeObserver(update);
      const header = document.getElementById('header-group');
      if (header) observer.observe(header);
      window.addEventListener('resize', update, { passive: true });

      const mediaHost = section.querySelector('.product-information__media');
      let gallery;
      let state;
      let cleanupGallery = () => {};
      const setupGallery = () => {
        const nextGallery = mediaHost?.querySelector('media-gallery');
        if (!nextGallery || nextGallery === gallery) return;
        cleanupGallery();
        gallery = nextGallery;
        const viewport = gallery.querySelector('.media-gallery__grid');
        const thumbnails = gallery.querySelector('.egde-product-thumbnails');
        const currentLabel = gallery.querySelector('[data-egde-current-image]');
        if (!viewport || !thumbnails || !currentLabel) return;
        const items = Array.from(viewport.children);
        const buttons = Array.from(thumbnails.querySelectorAll('[data-egde-image-index]'));
        const previous = state;
        state = { selected: gallery.dataset.egdeSelectedMediaId, scrollTop: 0 };
        let currentIndex = -1;
        const itemTop = (item) => item.getBoundingClientRect().top - viewport.getBoundingClientRect().top + viewport.scrollTop;
        const updateCurrent = () => {
          state.scrollTop = viewport.scrollTop;
          const marker = viewport.scrollTop + Math.min(60, viewport.clientHeight * 0.1);
          let index = items.findIndex((item) => itemTop(item) + item.offsetHeight > marker);
          if (viewport.scrollTop < 2) index = 0;
          else if (viewport.scrollTop >= viewport.scrollHeight - viewport.clientHeight - 2) index = items.length - 1;
          index = Math.max(0, index);
          if (index === currentIndex) return;
          currentIndex = index;
          currentLabel.textContent = String(index + 1);
          buttons.forEach((button, i) => {
            if (i === index) button.setAttribute('aria-current', 'true');
            else button.removeAttribute('aria-current');
          });
          const button = buttons[index];
          if (!button) return;
          // Scroll only the thumbnail strip, never its ancestor page.
          const box = button.getBoundingClientRect();
          const rail = thumbnails.getBoundingClientRect();
          if (box.top < rail.top) thumbnails.scrollTop += box.top - rail.top;
          else if (box.bottom > rail.bottom) thumbnails.scrollTop += box.bottom - rail.bottom;
          if (box.left < rail.left) thumbnails.scrollLeft += box.left - rail.left;
          else if (box.right > rail.right) thumbnails.scrollLeft += box.right - rail.right;
        };
        const onThumbnail = (event) => {
          const button = event.target.closest('[data-egde-image-index]');
          if (!button || !thumbnails.contains(button)) return;
          const item = items[Number(button.dataset.egdeImageIndex)];
          if (!item) return;
          viewport.scrollTo({
            top: itemTop(item),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        };
        viewport.addEventListener('scroll', updateCurrent, { passive: true });
        thumbnails.addEventListener('click', onThumbnail);
        const galleryObserver = new ResizeObserver(updateCurrent);
        galleryObserver.observe(viewport);
        const selectionChanged = previous && previous.selected !== state.selected;
        const requestedVariant = !previous && new URLSearchParams(location.search).has('variant');
        const selectedItem = items.find((item) => item.dataset.egdeMediaId === state.selected);
        viewport.scrollTop = (selectionChanged || requestedVariant) && selectedItem
          ? itemTop(selectedItem)
          : previous?.scrollTop || 0;
        updateCurrent();
        cleanupGallery = () => {
          viewport.removeEventListener('scroll', updateCurrent);
          thumbnails.removeEventListener('click', onThumbnail);
          galleryObserver.disconnect();
        };
      };
      const mediaObserver = new MutationObserver(setupGallery);
      if (mediaHost) mediaObserver.observe(mediaHost, { childList: true });
      setupGallery();
      section.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        observer.disconnect();
        mediaObserver.disconnect();
        cleanupGallery();
        window.removeEventListener('resize', update);
      }, { once: true });
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
